/*
  Murray cart drawer — replaces the UpCart app.

  - Opens from the header cart icon and after any successful add to cart
    (theme product forms via ajaxProduct:added, anything else by watching
    /cart/add network requests).
  - Re-renders itself with the Section Rendering API so prices, compare-at
    prices and automatic discounts come straight from Liquid.
  - The checkout button is a normal name="checkout" submit with
    data-lasso-checkout, so the Lasso/Whop checkout script picks it up.
*/
(function () {
  if (window.__murrayCartReady) return;
  window.__murrayCartReady = true;

  var SECTION = 'murray-cart';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var openTimer = null;
  var lastFocus = null;

  function drawer() {
    return document.getElementById('MurrayCart');
  }

  function isCartAdd(url) {
    try {
      var path = new URL(url, location.origin).pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?\//i, '/');
      return /^\/cart\/add(\.js)?$/.test(path);
    } catch (e) {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url));
    }
  }

  function updateBubbles(count) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      el.classList.toggle('cart-link__bubble--visible', count > 0);
    });
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
      el.textContent = count;
    });
  }

  function apply(html) {
    var current = drawer();
    if (!current || !html) return;

    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var next = tmp.querySelector('#MurrayCart');
    if (!next) return;

    var scroll = current.querySelector('.mc__body');
    var scrollTop = scroll ? scroll.scrollTop : 0;

    current.querySelector('.mc__panel').innerHTML = next.querySelector('.mc__panel').innerHTML;
    current.dataset.count = next.dataset.count;

    var newScroll = current.querySelector('.mc__body');
    if (newScroll) newScroll.scrollTop = scrollTop;

    updateBubbles(parseInt(next.dataset.count, 10) || 0);
  }

  function refresh() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) { apply(data[SECTION]); })
      .catch(function (e) { console.error('[MurrayCart]', e); });
  }

  function open() {
    var el = drawer();
    if (!el || el.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mc-lock');
    var panel = el.querySelector('.mc__panel');
    if (panel) panel.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('drawerOpen'));
  }

  function close() {
    var el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function refreshAndOpen() {
    clearTimeout(openTimer);
    openTimer = setTimeout(function () {
      refresh().then(open);
    }, 60);
  }

  function change(key, quantity) {
    if (busy || !key) return;
    busy = true;
    var el = drawer();
    el.classList.add('is-loading');

    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity), sections: SECTION })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections[SECTION]) {
          apply(data.sections[SECTION]);
        } else {
          if (data && data.description) window.alert(data.description);
          return refresh();
        }
      })
      .catch(function (e) {
        console.error('[MurrayCart]', e);
        return refresh();
      })
      .finally(function () {
        busy = false;
        el.classList.remove('is-loading');
      });
  }

  // Header cart icon (capture phase so no other handler navigates to /cart)
  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest && evt.target.closest('.js-drawer-open-cart');
    if (!trigger || document.body.classList.contains('template-cart')) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    open();
  }, true);

  // Clicks inside the drawer
  document.addEventListener('click', function (evt) {
    var el = drawer();
    if (!el || !el.contains(evt.target)) return;

    if (evt.target.closest('[data-mc-close]')) {
      evt.preventDefault();
      close();
      return;
    }

    var qtyBtn = evt.target.closest('[data-mc-qty]');
    if (qtyBtn) {
      evt.preventDefault();
      var item = qtyBtn.closest('[data-key]');
      change(item && item.dataset.key, parseInt(qtyBtn.dataset.mcQty, 10));
    }
  });

  document.addEventListener('change', function (evt) {
    var input = evt.target.closest && evt.target.closest('#MurrayCart [data-mc-input]');
    if (!input) return;
    var item = input.closest('[data-key]');
    var qty = parseInt(input.value, 10);
    change(item && item.dataset.key, isNaN(qty) ? 0 : qty);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') close();
    if (evt.key === 'Enter' && evt.target.matches && evt.target.matches('#MurrayCart [data-mc-input]')) {
      evt.preventDefault();
      evt.target.blur();
    }
  });

  // Keep the drawer in sync with theme events
  document.addEventListener('cart:open', function () { refresh().then(open); });
  document.addEventListener('cart:close', close);
  document.addEventListener('cart:build', refresh);
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) refresh();
  });

  // Theme product forms: success events carry the added product
  document.addEventListener('ajaxProduct:added', function (evt) {
    if (evt.detail && evt.detail.product) {
      refreshAndOpen();
    } else {
      refresh();
    }
  });

  // Any other add to cart (apps, quick add). Watching finished network
  // requests instead of wrapping fetch, because the Lasso checkout script
  // replaces window.fetch after this file runs.
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (!isCartAdd(entry.name)) return;
          if (entry.responseStatus && entry.responseStatus >= 400) return;
          var before = parseInt((drawer() || {}).dataset ? drawer().dataset.count : 0, 10) || 0;
          clearTimeout(openTimer);
          openTimer = setTimeout(function () {
            refresh().then(function () {
              var after = parseInt(drawer().dataset.count, 10) || 0;
              if (after > before) open();
            });
          }, 120);
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  // Not window.MurrayCart: the #MurrayCart element already owns that global name
  window.murrayCartDrawer = { open: open, close: close, refresh: refresh };
})();
